import React from "react";
import { ArrowRight } from "@bloomberg/media-ui-icons";
import { createClasses } from "@bloomberg/media-ui-core";
import { GlobalProps } from "@bloomberg/media-ui-core/types";
import styles from "./yourWatchlist.module.css";

const YOUR_WATCHLIST_URL = `/markets/watchlist`;

export default function YourWatchlist(props: GlobalProps) {
  const cx = createClasses(styles.wrapper, props.className);

  return (
    <div className={cx}>
      <a className={styles.yourWatchlist} href={YOUR_WATCHLIST_URL}>
        View Your Watchlist
        <ArrowRight />
      </a>
    </div>
  );
}
